import {
    Box,
    styled,
    $error,
    $fontSize,
} from '@acko-tech/building-blocks.ui.common';

export const StyledBox = styled(Box)``;

export const ErrorText = styled.p`
    margin: 0;
    font-size: 11px;
    color: ${$error};
    white-space: pre-wrap;
    margin-bottom: 1em;
`;

export const FuelOptionsText = styled.p`
    width: 100%;
    margin: 0;
    font-size: ${$fontSize.xs};
    line-height: 22px;
    color: #040222;
`;

export const FuelTextContainer = styled(Box)`
    padding: 1rem 0;
    cursor: pointer;
    :not(:last-child) {
        border-bottom: 1px solid #dcdce0;
    }
    :first-child {
        padding-top: 4px;
    }
`;
